import React, {useContext, useEffect, useState} from "react";
import {MobileWrapper} from "../../common/MobileWrapper";
import Loader from "../../common/Loader";
import {handle3DSRedirectFlow} from "../Card/utilities";
import {StatusContext} from "../../../context/Status";
import {StatusMessage} from "../../StatusMessage";
import {ErrorAlertContext} from "../../../context/ErrorAlert";
import {RoutingContext} from "../../../context/Router";



export const ActivateMerchantCheckout = ({token}: {token?: string}) => {
    const {payData, merchantKey} = useContext(RoutingContext);



    const {onShowAlert} = useContext(ErrorAlertContext);
    const {setPageTransactionStatus} = useContext(StatusContext);
    const [transactionStatus, setTransactionStatus] = useState("loading");


    const statusString: Record<string, string> = {
        loading: "Loading...",
        success: "Transaction successful",
        error: "Transaction failed",
    };

    useEffect(() => {
        const initiate3dsRedirection = async () => {
            if (!token && merchantKey) return;

            await handle3DSRedirectFlow(
                token as string,
                payData.kit.tx_ref,
                merchantKey,
                setTransactionStatus,
                setPageTransactionStatus,
                onShowAlert
            );
        };

        initiate3dsRedirection().then((r) => r);
    }, [token, merchantKey]);

    if (
        transactionStatus === "error" ||
        transactionStatus === "success" ||
        transactionStatus === "pending"
    ) {
        return <StatusMessage type={transactionStatus}/>;
    }

    return (
        <MobileWrapper>
            <Loader isLoading={transactionStatus === "loading"}/>
            <h1>Merchant Checkout</h1>
            <p>{statusString[transactionStatus]}</p>
        </MobileWrapper>
    );
};
